import Info from "../models/Custom Marker/Info";
import HeavyUser from "../models/Custom Marker/HeavyUser";
import LeakFound from "../models/Custom Marker/LeakFound";
import OtherFound from "../models/Custom Marker/OtherFound";
import InvestigationArranged from "../models/Custom Marker/InvestigationArranged";
import RepairArranged from "../models/Custom Marker/RepairArranged";
import Alert from "../models/Custom Marker/Alert-Warning";
import store from "../store/index";

const isOK = response => {
  return response.status == 200 && response.data != null;
};

const isEquivalent = (a, b) => {
  // Create arrays of property names
  let aProps = Object.getOwnPropertyNames(a);
  let bProps = Object.getOwnPropertyNames(b);
  // If number of properties is different,
  // objects are not equivalent
  if (aProps.length !== bProps.length) {
    return false;
  }
  for (let i = 0; i < aProps.length; i++) {
    let propName = aProps[i];
    // If values of same property are not equal,
    // objects are not equivalent
    if (a[propName] !== b[propName]) {
      return false;
    }
  }
  // If we made it this far, objects
  // are considered equivalent
  return true;
};

const PoiDataConfidenceSort = (a, b) => {
  if (a.confidence > b.confidence) {
    return -1;
  }
  if (a.confidence < b.confidence) {
    return 1;
  }
  return 0;
};

const GetRandomSalt = size => {
  let charset =
    "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let result = "";
  for (let i = 0; i < size; i++) {
    result += charset[Math.floor(Math.random() * charset.length)];
  }
  return result;
};

//TODO: as colour values for materials
const MaterialDetails = {
  0: { name: "Cast Iron", colour: "" },
  1: { name: "Concrete", colour: "" },
  2: { name: "Copper", colour: "" },
  3: { name: "Ductile Iron", colour: "" },
  4: { name: "Ductile Iron Concrete Lined", colour: "" },
  5: { name: "Galvanised Iron", colour: "" },
  6: { name: "HDPE", colour: "" },
  7: { name: "Lead", colour: "" },
  8: { name: "MDPE", colour: "" },
  9: { name: "PVC", colour: "" },
  10: { name: "Spun Iron", colour: "" },
  11: { name: "Steel", colour: "" },
  12: { name: "Steel Concrete Lined", colour: "" }
};

const MakeSpecialistMarkerData = (type, data) => {
  let dataAsClass = null;
  switch (type) {
    case 0:
      dataAsClass = new Info(data);
      break;
    case 1:
      dataAsClass = new HeavyUser(data);
      break;
    case 2:
      dataAsClass = new LeakFound(data);
      break;
    case 3:
      dataAsClass = new OtherFound(data);
      break;
    case 4:
      dataAsClass = data; // PRV
      break;
    case 5:
      dataAsClass = new InvestigationArranged(data);
      break;
    case 6:
      dataAsClass = new RepairArranged(data);
      break;
    case 7:
      dataAsClass = new Alert(data);
      break;
    default:
      dataAsClass = data;
      break;
  }

  return dataAsClass;
};

const PoiDataConfidenceCompare = (poiA, poiB) => {
  if (poiA.confidence > poiB.confidence) {
    return -1;
  }
  if (poiA.confidence < poiB.confidence) {
    return 1;
  }
  return 0;
};

const RemoveUndefined = obj => {
  // make sure no undefined exsist as fire base can't cope with them
  let keys = Object.keys(obj);
  keys.forEach(key => {
    if (obj[key] === undefined) {
      obj[key] = null;
    } else if (obj[key] instanceof Object) {
      let subkeys = Object.keys(obj[key]);
      subkeys.forEach(subkey => {
        if (obj[key][subkey] === undefined) {
          obj[key][subkey] = null;
        }
        if (obj[key][subkey] instanceof Object) {
          obj[key][subkey] = RemoveUndefined(obj[key][subkey]);
        }
      });
    }
  });
  return obj;
};

const IsNullOrWhitespace = input => {
  if (typeof input === "undefined" || input == null) return true;
  return input.replace(/\s/g, "").length < 1;
};

const DeepCompare = args => {
  let i, l, leftChain, rightChain;

  const CompareTwoObjects = (x, y) => {
    let p;

    // remember that NaN === NaN returns false
    // and isNaN(undefined) returns true
    if (
      isNaN(x) &&
      isNaN(y) &&
      typeof x === "number" &&
      typeof y === "number"
    ) {
      return true;
    }

    // Compare primitives and functions.
    // Check if both arguments link to the same object.
    // Especially useful on the step where we compare prototypes
    if (x === y) {
      return true;
    }

    // Works in case when functions are created in constructor.
    // Comparing dates is a common scenario. Another built-ins?
    // We can even handle functions passed across iframes
    if (
      (typeof x === "function" && typeof y === "function") ||
      (x instanceof Date && y instanceof Date) ||
      (x instanceof RegExp && y instanceof RegExp) ||
      (x instanceof String && y instanceof String) ||
      (x instanceof Number && y instanceof Number)
    ) {
      return x.toString() === y.toString();
    }

    // At last checking prototypes as good as we can
    if (!(x instanceof Object && y instanceof Object)) {
      return false;
    }

    if (x.isPrototypeOf(y) || y.isPrototypeOf(x)) {
      return false;
    }

    if (x.constructor !== y.constructor) {
      return false;
    }

    if (x.prototype !== y.prototype) {
      return false;
    }

    // Check for infinitive linking loops
    if (leftChain.indexOf(x) > -1 || rightChain.indexOf(y) > -1) {
      return false;
    }

    // Quick checking of one object being a subset of another.
    // todo: cache the structure of arguments[0] for performance
    for (p in y) {
      if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
        return false;
      } else if (typeof y[p] !== typeof x[p]) {
        return false;
      }
    }

    for (p in x) {
      if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
        return false;
      } else if (typeof y[p] !== typeof x[p]) {
        return false;
      }

      switch (typeof x[p]) {
        case "object":
        case "function":
          leftChain.push(x);
          rightChain.push(y);

          if (!CompareTwoObjects(x[p], y[p])) {
            return false;
          }

          leftChain.pop();
          rightChain.pop();
          break;

        default:
          if (x[p] !== y[p]) {
            return false;
          }
          break;
      }
    }

    return true;
  };

  if (args.length < 1) {
    return true; //Die silently? Don't know how to handle such case, please help...
    // throw "Need two or more arguments to compare";
  }

  for (i = 1, l = args.length; i < l; i++) {
    leftChain = []; //Todo: this can be cached
    rightChain = [];

    if (!CompareTwoObjects(args[0], args[i])) {
      return false;
    }
  }

  return true;
};

const CreateLogEntryObj = (poiId, action) => {
  const userId = store.getters["login/technicianId"];
  const userName = store.getters["login/authUser"].username;
  return {
    action: action,
    poiId: poiId,
    timestamp: new Date().toISOString(),
    userId: userId,
    userName: userName
  };
};

const toDateString = (val) => {
  var date = new Date(val);
  var days = date.getDate(),
  month = date.getMonth() + 1,
  year = date.getFullYear();
  var formattedTooltip = year + "-" + doubleDigit(month) + "-" + doubleDigit(days);
  return formattedTooltip
}

const toDateTimeString = (val) => {
  var date = new Date(val);
  var days = date.getDate(),
  month = date.getMonth() + 1,
  year = date.getFullYear(),
  hours = date.getHours(),
  mins = date.getMinutes();
  var formattedTooltip = year + "-" + doubleDigit(month) + "-" + doubleDigit(days) + " " + doubleDigit(hours) + ":" + doubleDigit(mins);
  return formattedTooltip
}

const doubleDigit = (val) => {
  if (val < 10) {
      return "0" + val;
  }
  return val;
}

export {
  isEquivalent,
  PoiDataConfidenceSort,
  GetRandomSalt,
  MaterialDetails,
  MakeSpecialistMarkerData,
  PoiDataConfidenceCompare,
  RemoveUndefined,
  IsNullOrWhitespace,
  DeepCompare,
  isOK,
  CreateLogEntryObj,
  toDateString,
  toDateTimeString,
};
